import React from 'react';

const Settings = () => {
  return (
    <>
      <h1 style={{ textAlign: 'center' }}>SETTINGS</h1>
    </>
  );
};

export default Settings;